import { useCallback, useEffect } from 'react';
import { Box, Loader } from '@betty/moonlight';
import { Navigate, useSearchParams } from 'react-router';
import { Page } from '@betty/navigation';
import PaymentLaunchService from '../services/PaymentLaunchService/PaymentLaunchService';
import { logError } from '@betty/toolkit/logging';

function InteracRedirectPage() {
  const [searchParams] = useSearchParams();

  const launchInterac = useCallback(async () => {
    const data = {
      amount: Number(searchParams.get('amount')),
      email: searchParams.get('email'),
      phoneNumber: searchParams.get('phoneNumber'),
      savePaymentDetails: Boolean(searchParams.get('savePaymentDetails')),
    };

    try {
      const { url, transactionId } = await PaymentLaunchService.depositInterac({
        data,
      });

      window.opener?.postMessage(
        JSON.stringify({ type: 'INTERAC_TRANSACTION_ID', transactionId }),
        '*',
      );

      window.location.assign(url);
    } catch (e) {
      logError('Interac redirect launch failure.', e);

      window.close();
    }
  }, [searchParams]);

  useEffect(() => {
    if (searchParams.size) {
      launchInterac();
    }
  }, [launchInterac, searchParams.size]);

  if (!searchParams.size) {
    return <Navigate to="/" replace />;
  }

  return (
    <Page>
      <Box absoluteFill centerContent>
        <Loader />
      </Box>
    </Page>
  );
}

export default InteracRedirectPage;
